import { render, staticRenderFns } from "./basic.vue?vue&type=template&id=0324ae73&scoped=true"
import script from "./basic.vue?vue&type=script&lang=js"
export * from "./basic.vue?vue&type=script&lang=js"
import style0 from "./basic.vue?vue&type=style&index=0&id=0324ae73&prod&lang=less"
import style1 from "./basic.vue?vue&type=style&index=1&id=0324ae73&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0324ae73",
  null
  
)

export default component.exports